import { da } from "../../../../date-fns/locale/da.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    da
  }
};